import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {Grouping} from './core/_models'
import {getAllGroupings} from './core/_requests'
import {ListGroupingsTable} from './components/ListGroupingsTable'

const GroupingsPage: FC<{subject: string}> = ({subject}) => {
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, setIsLoading] = useState(false)
  const [listGroupings, setListGroupings] = useState<Grouping[] | null>([])

  const fetchGroupings = () => {
    setIsLoading(true)
    getAllGroupings(axiosPrivate)
      .then((res) => {
        setListGroupings(res.data.table_data)
      })
      .catch((e) => {
        console.error('Failed to fetch groupings:', e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchGroupings()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Groupings Management
      </PageTitle>

      <div className='GroupingsPage'>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex align-items-center'>
                <div className='d-flex flex-column'>
                  <h3 className='text-primary'>Groupings Management</h3>
                  <p className='text-gray-700'>
                    In this module, you can manage economies grouping records.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-file-alt px-2'></span>
                      <h3 className='text-gray-700'>List Groupings</h3>
                    </div>
                    {ability.can('create', subject) ? (
                      <div className='card-action'>
                        <Link
                          to={'/groupings/add'}
                          className='btn btn-primary d-flex gap-4 align-items-center'
                        >
                          <span className='fa fa-plus'></span>
                          Add
                        </Link>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ListGroupingsTable
                  subject={subject}
                  onGroupingDelete={(deletedId) => {
                    setListGroupings((prev) =>
                      prev ? prev.filter((item) => item.id !== deletedId) : null
                    )
                  }}
                  rows={listGroupings}
                  isLoading={isLoading}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default GroupingsPage
